import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_auth = _resolveComponent("company-auth")!

  return (_openBlock(), _createBlock(_component_company_auth, {
    menuTab: _ctx.menuTab,
    type: _ctx.type
  }, null, 8, ["menuTab", "type"]))
}